export default __webpack_public_path__ + "static/media/igg.a2865f7a.svg";